<div class="modal fade" id="askFinishModal" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Czy na pewno chcesz zakończyć?</h5>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="askNo()">Nie</button>
				<button type="button" class="btn btn-primary" (click)="askYes()">Tak</button>
			</div>
		</div>
	</div>
</div>
<div class="modal fade" id="askRevertModal" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Czy na pewno chcesz przywrócić?</h5>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="askRNo()">Nie</button>
				<button type="button" class="btn btn-primary" (click)="askRYes()">Tak</button>
			</div>
		</div>
	</div>
</div>

<ul class="nav nav-tabs" id="myTab" role="tablist">
	<li class="nav-item">
		<a
			class="nav-link active"
			id="tasks-active-tab"
			data-bs-toggle="tab"
			href="#tasks-active"
			role="tab"
			aria-controls="tasks"
			aria-selected="false"
		>
			Zadania - Aktywne
		</a>
	</li>
	<li class="nav-item">
		<a
			class="nav-link"
			id="tasks-add-tab"
			data-bs-toggle="tab"
			href="#tasks-add"
			role="tab"
			aria-controls="tasks-add"
			aria-selected="false"
		>
			Dodaj zadanie
		</a>
	</li>
	<li class="nav-item">
		<a
			class="nav-link"
			id="tasks-completed-tab"
			data-bs-toggle="tab"
			href="#tasks-completed"
			role="tab"
			aria-controls="tasks-completed"
			aria-selected="false"
		>
			Zadania - Zakończone
		</a>
	</li>
	<li class="nav-item">
		<a
			class="nav-link"
			id="history-tab"
			data-bs-toggle="tab"
			href="#history"
			role="tab"
			aria-controls="history"
			aria-selected="false"
		>
			Historia
		</a>
	</li>
</ul>
<div class="tab-content" id="myTabContent">
	<div class="tab-pane fade active show" id="tasks-active" role="tabpanel" aria-labelledby="tasks-active-tab">
		<div class="card">
			<div class="card-body">
				<h5 class="card-title">Aktualne</h5>
				<div class="card-text">
					<div class="row" *ngFor="let item of tasksNew">
						<div class="col-sm-4">
							<button type="button" class="btn btn-link btn-sm me-2" (click)="askFinish(item.id)">
								Zakończ
							</button>
							<button type="button" class="btn btn-outline-light btn-sm {{ item.color }}" disabled>
								{{ item.type }}
							</button>
						</div>
						<div class="col-sm-8">
							<p>
								{{ item.content }}<br />
								<small>
									Utworzone przez: {{ item.author }} w dniu: {{ item.date_created }}<br />
									przypisane do: <b>{{ item.owner }}</b>
								</small>
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="tab-pane fade" id="tasks-add" role="tabpanel" aria-labelledby="tasks-add-tab">
		<div class="card">
			<div class="card-body">
				<div class="card-text">
					<form (submit)="submit()">
						<div class="mb-3 row">
							<label class="col-sm-3 col-form-label" for="content">Treść</label>
							<textarea
								class="col-sm-9 form-control"
								id="content"
								rows="3"
								name="lead.content"
								[(ngModel)]="lead.content"
								[ngClass]="{ error: this.errors.content }"
							></textarea>
						</div>
						<div class="mb-3 row">
							<label class="col-sm-3 col-form-label" for="start_date">Termin</label>
							<div class="row col-sm-9">
								<div class="col-sm-6 full-space">
									<input
										type="date"
										class="form-control"
										id="start_date"
										name="start_date"
										[(ngModel)]="lead.start_date"
										[ngClass]="{ error: this.errors.start_date }"
									/>
								</div>
								<div class="col-sm-6 full-space">
									<input
										type="time"
										class="form-control"
										name="start_time"
										[(ngModel)]="lead.start_time"
										[ngClass]="{ error: this.errors.start_time }"
									/>
								</div>
							</div>
						</div>
						<div class="mb-3 row">
							<label class="col-sm-3 col-form-label" for="type">Typ</label>
							<select
								class="col-sm-9 form-control"
								id="type"
								name="type"
								[(ngModel)]="lead.type"
								[ngClass]="{ error: this.errors.type }"
							>
								<option *ngFor="let item of types" value="{{ item.id }}">{{ item.name }}</option>
							</select>
						</div>
						<div class="mb-3 row">
							<label class="col-sm-3 col-form-label" for="user">Przypisane do</label>
							<ng-select
								class="col-sm-9"
								id="user"
								name="user"
								[(ngModel)]="lead.owner"
								[items]="users"
								placeholder="(wybierz)"
								bindLabel="name"
								bindValue="id"
							>
							</ng-select>
						</div>
						<div class="row">
							<div class="col-sm-3 text-end">&nbsp;</div>
							<div class="col-sm-9">
								<button type="submit" class="btn btn-primary">Dodaj</button>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>

	<div class="tab-pane fade" id="tasks-completed" role="tabpanel" aria-labelledby="tasks-completed-tab">
		<div class="card">
			<div class="card-body">
				<h5 class="card-title">Zakończone</h5>
				<div class="row" *ngFor="let item of tasksDone">
					<div class="col-sm-4">
						<button type="button" class="btn btn-link btn-sm me-2" (click)="askRevert(item.id)">
							Przywróć
						</button>
						<button type="button" class="btn btn-outline-light btn-sm {{ item.color }}" disabled>
							{{ item.type }}
						</button>
					</div>
					<div class="col-sm-8">
						<p>
							{{ item.content }}<br />
							<small>
								Utworzone przez: {{ item.author }} w dniu: {{ item.date_created }}<br />
								przypisane do: <b>{{ item.owner }}</b>
							</small>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="tab-pane fade" id="history" role="tabpanel" aria-labelledby="history-tab"></div>
</div>
